import { ThemeProvider } from 'styled-components';
import { CommonThemeProvider, ThemeProsolve } from '@prosolve/common-components-ui';
import BackgroundImage from './images/hub-app-module-background.png'

// THEME SELECTION DISABLED — the portal must only ever use the light theme.
// To re-enable theme selection ('Light'/'Dark' and browser dark preference),
// restore the commented code below and remove isHideTheme={true} from HubTopNav in Main/Main.js.
// import { useEffect, useState } from 'react';
// import { CommonThemeProvider, ThemeProsolve, ThemeProsolveDark, useCommonThemeData } from '@prosolve/common-components-ui';
// import useMediaQuery from './hooks/useMediaQuery';
// import BackgroundImageDark from './images/hub-app-module-background-dark.jpg'

const themes = [
  { props: ThemeProsolve }
]
// const themes = [
//   { name: '-', props: ThemeProsolve, darkProps: ThemeProsolveDark },
//   { name: 'Light', props: ThemeProsolve, darkProps: ThemeProsolveDark },
//   { name: 'Dark', props: ThemeProsolveDark, darkProps: ThemeProsolveDark }
// ]

const localTheme = {
  ...ThemeProsolve,
  isDark: false,
  images: {
    background: `${BackgroundImage}`
  }
}

// const localThemeDark = {
//   ...ThemeProsolveDark,
//   isDark: true,
//   images: {
//     background: `${BackgroundImageDark}`
//   }
// }

export default ({children}) => {
  return (
    <CommonThemeProvider themes={themes}>
      <InternalWrapper>
        {children}
      </InternalWrapper>
    </CommonThemeProvider>
  )
}

const InternalWrapper = ({ children }) => {
  // THEME SELECTION DISABLED — restore the commented code below (and swap localTheme for theme) to re-enable
  // const [theme, setTheme] = useState(localTheme)
  //
  // const { preferredTheme } = useCommonThemeData()
  // const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')
  //
  // useEffect(() => {
  //   const isPrefersDark = preferredTheme ? preferredTheme.includes('Dark') : prefersDarkMode
  //   const theme = (isPrefersDark ? localThemeDark : localTheme)
  //   setTheme(theme)
  // }, [preferredTheme, prefersDarkMode])

  return (
    <ThemeProvider theme={localTheme}>
      {children}
    </ThemeProvider>
  )
}
